import "./officeAndWorker.css";
import ContinerOffice from "./ContinerOffice";
import AppUsers from "./AppUsers";
import { useEffect, useState } from "react";
import { fetcSaveAdminUsers } from "../../../faetures/fetchSave";
import FetchMassage from "../../../faetures/FetchMassage";


function AppOfficeAndWorker() {
    const [data, setData] = useState({});
    const [openUsers, setOpenUsers] = useState(0);
    const [massage, setMassage] = useState(
        {text: "", data: "", url: "", open: false, fun: () => {}}
    );

    useEffect(() => {

        const fetchData = async () => {
            try {
                const resolve = await fetcSaveAdminUsers();

                setData(resolve);
            } catch (error) {
                setData({});
            }
        }

        fetchData();

    }, [])

    const hendaleClickAddOffice = () => {
        setData({...data, 0: {
            name: "", num: "", p: "b", workers: {}
        }})
    }

    return (<>
        <div className={"OfficeAndWorker"}>

            <div className={"OfficeAndWorker-add-office"} onClick={hendaleClickAddOffice}>
                <p>הוסף משרד</p>
            </div>

            {
            Object.keys(data).map((keyData, key) => (
                    <ContinerOffice
                    key={keyData}
                    disable={true}
                    office={data[keyData]["num"]}
                    name={data[keyData]["name"]}
                    permissions={data[keyData]["p"]}
                    onDubleClick={() => setOpenUsers(keyData)}
                    setMassageFetch={setMassage}
                    keyContiner={keyData}
                    setDataFromServer={(key, newData) => setData({...data, [key]: {...data[key], ...newData}})}
                    />
                ))
            }
        </div>

        {
            openUsers !== 0 && 
            <AppUsers 
            setClose={() => setOpenUsers(0)}
            data={data[openUsers]}
            setAdd={() => setData({...data, [openUsers]: {...data[openUsers], workers: {
                ...data[openUsers]['workers'], 0: {email: '', name: '', phone: '', user: ''}
            }}})}
            setMassage={setMassage}
            id_office={openUsers}
            />
        }

        {
            massage.open &&
            <FetchMassage
            text={massage.text}
            url={massage.url}
            data={massage.data}
            fun={massage.fun}
            setClose={() => setMassage({text: "", data: "", url: "", open: false, fun: () => {}})}
            setMassage={setMassage}
            />
        }
    </>)
}


export default AppOfficeAndWorker;